import script from "./MetricsCards.vue?vue&type=script&setup=true&lang=js"
export * from "./MetricsCards.vue?vue&type=script&setup=true&lang=js"

import "./MetricsCards.vue?vue&type=style&index=0&id=7cf54e38&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cf54e38"]])

export default __exports__